<mat-form-field [formGroup]="form">
	<mat-label>
		<span cmLocalize="Core/System.Table.Label.SelectionFilter" default="Filter by Selection"></span>
	</mat-label>
	<mat-select formControlName="filter">
		<mat-option [value]="null">
			<span cmLocalize="Core/System.Table.MenuItem.SelectionFilterAll">All</span>
		</mat-option>
		<mat-option [value]="true">
			<span cmLocalize="Core/System.Table.MenuItem.SelectionFilterSelected">Selected</span>
		</mat-option>
		<mat-option [value]="false">
			<span cmLocalize="Core/System.Table.MenuItem.SelectionFilterUnselected">Unselected</span>
		</mat-option>
	</mat-select>
</mat-form-field>
